import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isValidEmail(
  control: AbstractControl
): ValidationErrors | null {
  const emailRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  if (!control.value) {
    return null;
  }
  return control.value &&
    control.value?.length >= 10 &&
    emailRegex.test(control.value)
    ? null
    : { email: true };
}
